<template>
  <div>
    <el-collapse-item title="报名表基本信息" name="interview_from_basic">
      <el-row>
        <el-col :span="2">申请学期</el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="formData.custom_year"
            format="yyyy"
            value-format="yyyy"
            type="year"
            placeholder="选择日期"
            style="width: 100px"
          />年
          <el-date-picker
            v-model="formData.custom_month"
            format="MM"
            value-format="MM"
            type="month"
            placeholder="选择日期"
            style="width: 100px"
          />月
        </el-col>
        <el-col :span="2">申请学校</el-col>
        <el-col :span="6">
          <el-input v-model="formData.apply_school" class="width150" />
        </el-col>
        <el-col :span="2">申请学校专业</el-col>
        <el-col :span="6">
          <el-input v-model="formData.apply_subject" class="width150" />
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="2">父母是否离异</el-col>
        <el-col :span="6">
          <el-select v-model="formData.leave" clearable>
            <el-option :value="1" :key="1" label="是" />
            <el-option :value="0" :key="0" label="否" />
          </el-select>
        </el-col>
        <el-col :span="2">全家一个户口本</el-col>
        <el-col :span="6">
          <el-select v-model="formData.booklet" clearable>
            <el-option :value="1" :key="1" label="是" />
            <el-option :value="0" :key="0" label="否" />
          </el-select>
        </el-col>
        <el-col :span="2">国籍</el-col>
        <el-col :span="6">
          <el-input v-model="formData.family_native_place" class="width150" />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">出生地</el-col>
        <el-col :span="6">
          <jm-areaselect v-model="bornplace" @change="setBornPlaceData" />
        </el-col>
        <el-col :span="2">邮编</el-col>
        <el-col :span="6">
          <el-input v-model="formData.postal_code" class="width150" />
        </el-col>
        <el-col :span="2">邮箱地址</el-col>
        <el-col :span="6">
          <el-input v-model="formData.email" class="width150" />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">婚姻状况</el-col>
        <el-col :span="6">
          <jm-dict-select
            class="width150"
            clearable
            type="dataset"
            v-model="formData.married"
            dict-type="student"
            name="married"
          />
        </el-col>
        <el-col :span="2">家庭现住址</el-col>
        <el-col :span="14">
          <jm-areaselect v-model="nowplace" @change="setNowPlaceData" />
          <el-input v-model="formData.now_place" class="width300" />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">学信网帐号</el-col>
        <el-col :span="6">
          <el-input v-model="formData.korea_xuexin" class="width150" />
        </el-col>
        <el-col :span="2">学信网密码</el-col>
        <el-col :span="14">
          <el-input v-model="formData.korea_xuexin_password" class="width150" />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">护照情况</el-col>
        <el-col :span="6">
          <jm-dict-select
            class="width100"
            clearable
            type="dataset"
            v-model="formData.has_passport"
            dict-type="student"
            name="hasPassport"
          />
        </el-col>
        <el-col :span="2">护照号</el-col>
        <el-col :span="14">
          <el-input v-model="formData.port_num" v-if="formData.has_passport === 1" class="width150" />
          <span v-else>暂无</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">最终学历</el-col>
        <el-col :span="6">
          <jm-dict-select
            class="width100"
            clearable
            dict="online.interview_education_2020"
            v-model="formData.final_edu"
            @change="() => formData.final_subject = ''"
          />
        </el-col>
        <el-col :span="2">最终学历专业</el-col>
        <el-col :span="6">
          <el-input
            class="width150"
            v-if="formData.final_edu !== 2054"
            v-model="formData.final_subject"
          />
          <jm-dict-select
            v-else
            class="width150"
            clearable
            type="dataset"
            v-model="formData.final_subject"
            dict-type="student"
            name="examSubject"
          />
        </el-col>
        <el-col :span="2">平均分</el-col>
        <el-col :span="6">
          <el-input v-model="formData.apply_avescore" class="width150" />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">高考</el-col>
        <el-col :span="6">
          <jm-dict-select dict="dataset.student.examStatus" class="width100" v-model="hasGaoKao" />
        </el-col>
        <template v-if="hasGaoKao">
          <el-col :span="2">文理</el-col>
          <el-col :span="6">
            <jm-dict-select
              clearable
              class="width100"
              dict="dataset.student.examSubject"
              v-model="formData.gaokao"
            />
          </el-col>
          <el-col :span="2">分数</el-col>
          <el-col :span="6">
            <el-input v-model="formData.gaokao_score" class="width150" />
          </el-col>
        </template>
        <template v-else>
          <el-col :span="16"></el-col>
        </template>
      </el-row>
      <el-row>
        <el-col :span="2">会考</el-col>
        <el-col :span="6">
          <jm-dict-select
            dict="dataset.student.examStatus"
            class="width100"
            v-model="hasGeneralExam"
          />
        </el-col>
        <template v-if="hasGeneralExam">
          <el-col :span="2">文理</el-col>
          <el-col :span="6">
            <jm-dict-select
              clearable
              class="width100"
              dict="dataset.student.examSubject"
              v-model="formData.general_exam"
            />
          </el-col>
          <el-col :span="2">分数/等级</el-col>
          <el-col :span="6">
            <el-input v-model="formData.general_exam_score" class="width150" />
          </el-col>
        </template>
        <template v-else>
          <el-col :span="16"></el-col>
        </template>
      </el-row>
      <el-row>
        <el-col :span="2">艺术生</el-col>
        <el-col :span="6">
          <jm-dict-select
            class="width100"
            clearable
            type="dataset"
            v-model="formData.art_exam"
            dict-type="student"
            name="isDeny"
          />
        </el-col>
        <el-col :span="2">艺考</el-col>
        <el-col :span="6">
          <jm-dict-select
            dict="dataset.student.examStatus"
            class="width100"
            v-model="formData.is_art_exam"
          />
        </el-col>
        <template v-if="formData.is_art_exam">
          <el-col :span="2">分数</el-col>
          <el-col :span="6">
            <el-input v-model="formData.art_exam_score" class="width150" />
          </el-col>
        </template>
        <template v-else>
          <el-col :span="16"></el-col>
        </template>
      </el-row>

      <el-row class="row-gray" v-if="formData.education_experience">
        <el-col :span="2">教育经历</el-col>
        <el-col :span="5">学校名称</el-col>
        <el-col :span="7">学校类型</el-col>
        <el-col :span="5">开始时间</el-col>
        <el-col :span="5">结束时间</el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.education_experience" :key="`kredu-${index}`">
        <el-col :span="2"></el-col>
        <el-col :span="5">
          <el-input v-model="item.sh_name" class="width200" />
        </el-col>
        <el-col :span="7">
          <jm-dict-select
            class="width150"
            clearable
            type="dataset"
            value-type="string"
            v-model="item.sh_type"
            dict-type="interviewForm"
            :name="['eduTypeKorea', 'koEduTypeOther']"
          />
          <el-input v-model="item.other_value" v-show="item.sh_type === '其他'" />
        </el-col>
        <el-col :span="5">
          <el-date-picker
            v-model="item.start_time"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="5">
          <el-date-picker
            v-model="item.end_time"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
      </el-row>
      <el-row class="row-gray" v-if="formData.japanese_experience">
        <el-col :span="3">韩语学习经历</el-col>
        <el-col :span="6">学校/机构名称</el-col>
        <el-col :span="5">开始时间</el-col>
        <el-col :span="5">结束时间</el-col>
        <el-col :span="5">级别</el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.japanese_experience" :key="`krlearn-${index}`">
        <el-col :span="3"></el-col>
        <el-col :span="6">
          <el-input v-model="item.name" class="width150" />
        </el-col>
        <el-col :span="5">
          <el-date-picker
            class="width150"
            v-model="item.starttime"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
          ></el-date-picker>
        </el-col>
        <el-col :span="5">
          <el-date-picker
            v-model="item.endtime"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="5">
          <el-input v-model="item.level" />
        </el-col>
      </el-row>

      <el-row class="row-gray" v-if="formData.is_japanese_exam">
        <el-col :span="3">韩语考试经历</el-col>
        <el-col :span="6">考试种类</el-col>
        <el-col :span="5">参加状态</el-col>
        <el-col :span="5">考试时间</el-col>
        <el-col :span="5">等级</el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.japanese_exam" :key="`krexam-${index}`">
        <el-col :span="3"></el-col>
        <el-col :span="6">
          <jm-dict-select
            class="width100"
            clearable
            type="dataset"
            v-model="item.etype"
            dict-type="interviewForm"
            value-type="string"
            name="examTypeKr"
          />
        </el-col>
        <el-col :span="5">
          <jm-dict-select
            class="width150"
            clearable
            type="dataset"
            v-model="item.exam_status"
            dict-type="interviewForm"
            name="examStatus"
          />
        </el-col>
        <el-col :span="5">
          <el-date-picker
            v-model="item.time"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="5">
          <el-input v-model="item.otherlevel" v-if="item.etype === 'other'" />
          <jm-dict-select
            v-if="item.etype === 'topik'"
            class="width150"
            clearable
            type="dataset"
            v-model="item.exam_level"
            dict-type="interviewForm"
            name="topik"
          />
        </el-col>
      </el-row>

      <el-row class="row-gray" v-if="formData.is_english_exam">
        <el-col :span="3">英语考试经历</el-col>
        <el-col :span="4">考试种类</el-col>
        <el-col :span="4">参加状态</el-col>
        <el-col :span="4">考试时间</el-col>
        <el-col :span="9">分数</el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.english_exam" :key="`enexam-${index}`">
        <el-col :span="3"></el-col>
        <el-col :span="4">
          <jm-dict-select
            class="width100"
            clearable
            type="dataset"
            value-type="string"
            v-model="item.etype"
            dict-type="interviewForm"
            name="enExamType"
          />
        </el-col>
        <el-col :span="4">
          <jm-dict-select
            class="width150"
            clearable
            type="dataset"
            v-model="item.exam_status"
            dict-type="interviewForm"
            name="examStatus"
          />
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="item.time"
            format="yyyy/MM"
            value-format="yyyy/MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="9">
          总：
          <el-input class="width60" v-model="item.score1" />L：
          <el-input class="width60" v-model="item.score2" />R：
          <el-input class="width60" v-model="item.score3" />S：
          <el-input class="width60" v-model="item.score4" />W：
          <el-input class="width60" v-model="item.score5" />
        </el-col>
      </el-row>

      <el-row class="row-gray" v-if="formData.work_experience">
        <el-col :span="2">职历</el-col>
        <el-col :span="5">公司名称</el-col>
        <el-col :span="4">在职状态</el-col>
        <el-col :span="5">入职时间</el-col>
        <el-col :span="5">离职时间</el-col>
        <el-col :span="3"></el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.work_experience" :key="`krwork-${index}`">
        <el-col :span="2"></el-col>
        <el-col :span="5">
          <el-input v-model="item.name" class="width150" />
        </el-col>
        <el-col :span="4">
          <jm-dict-select
            class="width150"
            clearable
            type="dataset"
            v-model="item.company_status"
            dict-type="interviewForm"
            name="jobStatus"
          />
        </el-col>
        <el-col :span="5">
          <el-date-picker
            v-model="item.starttime"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="5" v-if="parseInt(item.company_status) === 0">
          <el-date-picker
            v-model="item.endtime"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="3" v-if="parseInt(item.company_status) === 0"></el-col>
        <el-col :span="8" v-if="parseInt(item.company_status) === 1"></el-col>
      </el-row>
      <el-row class="row-gray" v-if="formData.japan_experience">
        <el-col :span="3">韩国签证申请历史</el-col>
        <el-col :span="6">签证类型</el-col>
        <el-col :span="5">获签时间</el-col>
        <el-col :span="5">是否拒签</el-col>
        <el-col :span="5">拒签理由</el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.japan_experience" :key="`apply-history-${index}`">
        <el-col :span="3"></el-col>
        <el-col :span="6">
          <el-input v-model="item.visatype" class="width150" />
        </el-col>
        <el-col :span="5">
          <el-date-picker
            v-model="item.gettime"
            format="yyyy/MM"
            value-format="yyyy/MM"
            type="month"
            placeholder="选择日期"
            class="width150"
          ></el-date-picker>
        </el-col>
        <el-col :span="5">
          <jm-dict-select
            class="width150"
            clearable
            type="dataset"
            v-model="item.deny"
            dict-type="student"
            name="isDeny"
          />
        </el-col>
        <el-col :span="5">
          <el-input v-model="item.denytext" class="width150" v-show="item.deny" />
        </el-col>
      </el-row>
    </el-collapse-item>

    <el-collapse-item title="报名表亲朋情况" name="interview_from_relation">
      <el-row class="row-gray" v-if="formData.family_member">
        <el-col :span="2">家族成员情况</el-col>
        <el-col :span="2">姓名</el-col>
        <el-col :span="5">与本人关系</el-col>
        <el-col :span="2">年龄</el-col>
        <el-col :span="3">就职公司/学校</el-col>
        <el-col :span="2">职业</el-col>
        <el-col :span="4">联系电话</el-col>
        <el-col :span="4">年收入（RMB）</el-col>
      </el-row>
      <el-row v-for="(item, index) in formData.family_member" :key="`krfamily-${index}`">
        <el-col :span="2"></el-col>
        <el-col :span="2">
          <el-input v-model="item.name" />
        </el-col>
        <el-col :span="5">
          <jm-dict-select
            v-model="item.relation"
            type="dataset"
            value-type="string"
            dict-type="interviewForm"
            name="relations"
            class="width100"
          />
          <el-input v-show="item.relation === '其他'" v-model="item.othername" />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.age" />
        </el-col>
        <el-col :span="3">
          <el-input v-model="item.company" />
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.job" />
        </el-col>
        <el-col :span="4">
          <el-input v-model="item.phone" />
        </el-col>
        <el-col :span="4">
          <el-input v-model="item.income" />
        </el-col>
      </el-row>
      <el-row></el-row>
    </el-collapse-item>
  </div>
</template>
<script>
import interviewMixin from './interviewFormMixin';

export default {
  name: 'InterviewFormKo',
  mixins: [interviewMixin]
};
</script>
